import { Injectable, inject } from '@angular/core';
import { firstValueFrom, ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { SettingsService } from '../../services/settings.service';

import firebase from 'firebase/compat/app';
import 'firebase/compat/remote-config';
import 'firebase/compat/firestore';

@Injectable({
    providedIn: 'root'
})
export class FirebaseService {
    private readonly auth = inject(AuthService);
    private readonly settingSvc = inject(SettingsService);

    private readonly firebaseReady = new ReplaySubject<boolean>(1);
    public firebaseReady$ = this.firebaseReady.asObservable();

    public initListener() {
        this.auth.isAuthenticated$.pipe(
            filter(isAuth => isAuth === true)
        ).subscribe(() => {
            void this.initFirebase();
        });
    }

    private async initFirebase(): Promise<void> {
        if (firebase.apps.length > 0) {
            this.firebaseReady.next(true);
            return;
        }

        try {
            const setting = await firstValueFrom(this.settingSvc.getSettingsValue('firebase-config'));

            const parsedConfig = typeof setting.values === 'string'
                ? JSON.parse(setting.values)
                : (setting.values || setting);

            const realConfig = {
                apiKey: parsedConfig.apiKey,
                authDomain: parsedConfig.authDomain,
                projectId: parsedConfig.projectId,
                storageBucket: parsedConfig.storageBucket,
                messagingSenderId: parsedConfig.messagingSenderId,
                appId: parsedConfig.appId,
                measurementId: parsedConfig.measurementId
            };

            firebase.initializeApp(realConfig);

            const remoteConfig = firebase.remoteConfig();
            remoteConfig.settings.minimumFetchIntervalMillis = 0;
            await remoteConfig.fetchAndActivate();

            this.firebaseReady.next(true);

        } catch (error) {
            console.error('Error al obtener la configuración o inicializar Firebase:', error);
            this.firebaseReady.next(false);
        }
    }
}